export const ONBOARDING_SECTIONS = [
  'group-code',
  'basic-info',
  'professional-info',
  'social-info',
  'activity-info',
] as const;

export type OnboardingSection = typeof ONBOARDING_SECTIONS[number];
